export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_complete_1.d9f80f43.jpg";